import { FC } from 'react'
import { ILesson, SectionType } from 'shared/types'
import { dbUpdateLesson } from 'controllers/lessons'
import { HStack, Tag, TagCloseButton, TagLabel, VStack } from '@chakra-ui/react'
import SimpleInput from 'shared/components/SimpleInput'
import LanguageSelector from 'components/LanguageSelector'
import map from 'lodash/map'
import get from 'lodash/get'
import filter from 'lodash/filter'
import { useSelector } from 'model/hooks'
import CardsSearch from 'components/CardsSearch'
import { createSection } from 'controllers/sections'
import Label from 'shared/components/Label'

type Props = {
  l: ILesson
}

const DictionarySettings: FC<Props> = ({ l }) => {
  const wordCards = useSelector(state => state.wordCards)

  const onChange = (upd: Partial<ILesson>) => {
    dbUpdateLesson(l.id, upd)
  }

  const onDeleteSection = (sId: string) => {
    const newOrder = filter(l.sectionsOrder, lId => lId !== sId)
    const newSections = { ...l.sections }
    delete newSections[sId]
    const upd = { sections: newSections, sectionsOrder: newOrder }
    dbUpdateLesson(l.id, upd)
  }

  const renderDictWords = () => {
    return (
      <HStack spacing={2} pt={2} wrap={'wrap'}>
        {map(l.sectionsOrder, sId => {
          const s = get(l.sections, sId)
          if (s && s.type === SectionType.WORD_CARD) {
            const card = get(wordCards, s.cardId)
            if (card) {
              return (
                <Tag
                  size={'sm'}
                  key={sId}
                  borderRadius='full'
                  variant='solid'
                  colorScheme='wood'
                >
                  <TagLabel>{card.word}</TagLabel>
                  <TagCloseButton onClick={() => onDeleteSection(sId)} />
                </Tag>
              )
            }
          }
        })}
      </HStack>
    )
  }

  const onAddCard = (cardId: string) => {
    const s = { ...createSection(SectionType.WORD_CARD), cardId }

    const newSections = {
      ...(l.sections || {}),
      [s.id]: s
    }
    const newSectionsOrder = [...(l.sectionsOrder || []), s.id]
    const upd = {
      sections: newSections,
      sectionsOrder: newSectionsOrder
    }
    dbUpdateLesson(l.id, upd)
  }

  const renderAddCard = () => {
    return (
      <VStack w='full' align={'start'}>
        <CardsSearch
          title={''}
          onSelect={v => onAddCard(v)}
          lang={l.dictionary?.lang}
        />
      </VStack>
    )
  }

  return (
    <VStack w='full' spacing={6} align={'start'}>
      <SimpleInput
        label='Название'
        value={l.name || ''}
        onChange={(v: string) => onChange({ name: v })}
      />
      <LanguageSelector
        value={l.dictionary?.lang}
        onChange={(v: string) => onChange({ dictionary: { lang: v } })}
      />
      <VStack w='full' pt={12} align={'start'}>
        <Label>Управление словами этой страницы:</Label>
        {renderDictWords()}
        {renderAddCard()}
      </VStack>
    </VStack>
  )
}

export default DictionarySettings
